import {useLegacyModalContext} from '~/components/legacy_modal/modal_context'
import {Dropdown, DropdownItem} from '~/components/dropdown'
import _ from 'lodash'
import {t} from '@eitje/bridge'

export const FieldsDropdown = ({type, fieldIndex}) => {
	const {availableFields, selectedFieldObjects, setSelectedFieldObjects, modelKey, clearableFields} = useLegacyModalContext()
	const clearableFieldNames = Object.keys(clearableFields || {})

	const handleSelect = field => setSelectedFieldObjects(currentFields => _.set([...currentFields], fieldIndex, {field, type}))

	const dropdownItems = availableFields.map(child => {
		const {field, disabled} = child.props

		if (type === 'clear' && !clearableFieldNames.includes(field)) return null

		const fieldName = `records.${modelKey}.fields.${field}`

		const isAlreadySelected = _.find(selectedFieldObjects, {field})
		const alreadySelectedMessage =
			isAlreadySelected && t(`modals.multi_action.disabled.already_in_${isAlreadySelected.type}`, {fieldName: t(fieldName)})

		return <DropdownItem key={field} t={fieldName} disabled={disabled || alreadySelectedMessage} onClick={() => handleSelect(field)} />
	})

	return <Dropdown trigger={{t: `modals.multi_action.type.${type}`}}>{dropdownItems}</Dropdown>
}
